<script setup lang="ts">
import { VTooltip } from 'vuetify/components';

type PropsType = {
    location?: VTooltip['$props']['location'];
    activator?: VTooltip['$props']['activator'];
    disabled?: VTooltip['$props']['disabled'];
    text?: VTooltip['$props']['text'];
    openDelay?: VTooltip['$props']['openDelay'];
    closeDelay?: VTooltip['$props']['closeDelay'];
    maxWidth?: VTooltip['$props']['maxWidth'];
    minWidth?: VTooltip['$props']['minWidth'];
    offset?: VTooltip['$props']['offset'];
    contentClass?: VTooltip['$props']['contentClass'];
};

withDefaults(defineProps<PropsType>(), {
    location: 'top',
    disabled: false,
    openDelay: 0,
    closeDelay: 0,
    contentClass: 'bg-grey-700',
});

defineOptions({ inheritAttrs: false });
</script>

<template>
    <VTooltip
        v-bind="$attrs"
        :location="location"
        :activator="activator"
        :disabled="disabled"
        :text="text"
        :open-delay="openDelay"
        :close-delay="closeDelay"
        :max-width="maxWidth"
        :min-width="minWidth"
        :offset="offset"
        :content-class="contentClass"
        class="b-tooltip"
    >
        <template
            v-if="$slots.activator"
            #activator="activatorProps"
        >
            <slot
                name="activator"
                v-bind="activatorProps"
            />
        </template>
        <slot />
    </VTooltip>
</template>
